/** Ordinamento colonne per tabelle: hook useTableSort + intestazione cliccabile SortableTh. */
import React from "react";
import { ChevronUp, ChevronDown, ChevronsUpDown } from "lucide-react";

export const useTableSort = () => {
  const [sortKey, setSortKey] = React.useState(null);
  const [sortDir, setSortDir] = React.useState("asc");
  const toggle = (key) => {
    if (sortKey === key) {
      if (sortDir === "asc") setSortDir("desc");
      else { setSortKey(null); setSortDir("asc"); }
    } else { setSortKey(key); setSortDir("asc"); }
  };
  const sortList = (list, accessors = {}) => {
    if (!sortKey) return list;
    const acc = accessors[sortKey] || ((row) => row[sortKey]);
    return [...list].sort((a, b) => {
      const va = acc(a), vb = acc(b);
      if ((va == null || va === "") && (vb == null || vb === "")) return 0;
      if (va == null || va === "") return 1;
      if (vb == null || vb === "") return -1;
      const cmp = (typeof va === "number" && typeof vb === "number")
        ? va - vb
        : String(va).localeCompare(String(vb), "it", { numeric: true, sensitivity: "base" });
      return sortDir === "asc" ? cmp : -cmp;
    });
  };
  return { sortKey, sortDir, toggle, sortList };
};

export const SortableTh = ({ label, sortId, sort, align = "left", className = "" }) => {
  const active = sort.sortKey === sortId;
  const Icon = !active ? ChevronsUpDown : sort.sortDir === "asc" ? ChevronUp : ChevronDown;
  return (
    <th
      className={`p-3 text-xs font-semibold cursor-pointer select-none hover:bg-stone-100 transition-colors ${align === "right" ? "text-right" : "text-left"} ${active ? "text-[#8A1C2A]" : "text-stone-600"} ${className}`}
      onClick={() => sort.toggle(sortId)}
      title="Clicca per ordinare"
      data-testid={`sort-th-${sortId}`}
    >
      <span className={`inline-flex items-center gap-1 ${align === "right" ? "flex-row-reverse" : ""}`}>
        {label}
        <Icon className={`w-3 h-3 shrink-0 ${active ? "opacity-100" : "opacity-40"}`} />
      </span>
    </th>
  );
};
